import { ProjectDetailsDto } from 'types/projects.ts';
import { RSQL_AND } from 'utils/filterUtil.ts';
import InvoicesTable from '../../invoices/InvoicesTable.tsx';

type Props = {
    project: ProjectDetailsDto;
};

const InvoicesView = ({ project }: Props) => {
    const matterIds = project.matters?.map((m) => m.id) ?? [];
    const joinedMatterIds = matterIds.length > 0 ? matterIds.join(',') : '0';
    return (
        <div className="flex flex-col gap-4">
            <InvoicesTable
                passiveFilter={`matter.id=in=(${joinedMatterIds})`}
                disableExport
                paginatedFieldPassiveFilters={[
                    {
                        filterId: 'matterIdInFilter',
                        filters: `id=in=(${joinedMatterIds})`,
                        filterOperator: RSQL_AND,
                    },
                ]}
            />
        </div>
    );
};

export default InvoicesView;
